/* MBG mobile navigation drawer — off-canvas side drawer + overlay,
   replacing the old full-width push-down mobile-nav panel. Deliberately
   its own small vanilla-JS module (matching mbg-cart.js / mbg-quick-add.js
   / mbg-favourites.js elsewhere in this theme) rather than touching the
   legacy jQuery theme.MobileNav module, which is left inert simply by no
   longer using the class name it looks for. */
(function () {
  'use strict';

  var drawer = document.querySelector('[data-mbg-mobile-drawer]');
  var overlay = document.querySelector('[data-mbg-mobile-nav-overlay]');
  var toggle = document.querySelector('[data-mbg-mobile-nav-toggle]');
  if (!drawer || !overlay || !toggle) {
    return;
  }

  var closeBtn = drawer.querySelector('[data-mbg-mobile-nav-close]');
  var lastFocused = null;

  function focusableElements() {
    return drawer.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
  }

  function trapFocus(evt) {
    if (evt.key !== 'Tab') {
      return;
    }
    var items = focusableElements();
    if (!items.length) {
      return;
    }
    var first = items[0];
    var last = items[items.length - 1];
    if (evt.shiftKey && document.activeElement === first) {
      evt.preventDefault();
      last.focus();
    } else if (!evt.shiftKey && document.activeElement === last) {
      evt.preventDefault();
      first.focus();
    }
  }

  function openDrawer() {
    lastFocused = document.activeElement;
    drawer.hidden = false;
    overlay.hidden = false;
    // Two rAF-ish ticks so the transition runs from the hidden state
    // rather than jumping straight to open (removing [hidden] and
    // adding the animate-in class in the same frame skips the transition).
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        drawer.classList.add('mbg-mobile-drawer--open');
        overlay.classList.add('mbg-mobile-drawer__overlay--visible');
      });
    });
    toggle.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('mbg-mobile-nav-lock');
    document.addEventListener('keydown', onKeydown);
    // Focus the close button, not whatever happens to be first in DOM
    // order (previously the MBGLIVE logo link) — a useful interactive
    // control belongs at the initial focus point of a drawer, not the
    // branding text. Falls back to the first focusable element only if
    // the close button is somehow missing.
    var initialFocus = closeBtn || focusableElements()[0];
    if (initialFocus) {
      initialFocus.focus();
    }
  }

  function closeDrawer() {
    drawer.classList.remove('mbg-mobile-drawer--open');
    overlay.classList.remove('mbg-mobile-drawer__overlay--visible');
    toggle.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('mbg-mobile-nav-lock');
    document.removeEventListener('keydown', onKeydown);
    window.setTimeout(function () {
      if (!drawer.classList.contains('mbg-mobile-drawer--open')) {
        drawer.hidden = true;
        overlay.hidden = true;
      }
    }, 320);
    if (lastFocused) {
      lastFocused.focus();
    }
  }

  function onKeydown(evt) {
    if (evt.key === 'Escape') {
      closeDrawer();
      return;
    }
    trapFocus(evt);
  }

  toggle.addEventListener('click', function () {
    if (drawer.classList.contains('mbg-mobile-drawer--open')) {
      closeDrawer();
    } else {
      openDrawer();
    }
  });

  if (closeBtn) {
    drawer.addEventListener(
      'click',
      function (evt) {
        var closeTarget = evt.target.closest('[data-mbg-mobile-nav-close]');
        if (!closeTarget) return;
        evt.preventDefault();
        evt.stopPropagation();
        closeDrawer();
      },
      true
    );
  }

  overlay.addEventListener('click', closeDrawer);

  // Any real destination link (menu items, utility row) closes the
  // drawer on its way there — including tapping the item whose href is
  // the homepage, which both closes the drawer and navigates home.
  drawer.querySelectorAll('[data-mbg-mobile-nav-navigate]').forEach(function (link) {
    link.addEventListener('click', function () {
      closeDrawer();
    });
  });

  // Inline accordion for the one dropdown level (e.g. SHOP) — expands
  // in place rather than sliding to a separate panel.
  drawer.querySelectorAll('[data-mbg-mobile-submenu-toggle]').forEach(function (submenuToggle) {
    var submenu = submenuToggle.nextElementSibling;
    if (!submenu) {
      return;
    }
    submenuToggle.addEventListener('click', function () {
      var isOpen = submenuToggle.getAttribute('aria-expanded') === 'true';

      drawer.querySelectorAll('[data-mbg-mobile-submenu-toggle]').forEach(function (otherToggle) {
        if (otherToggle === submenuToggle) return;
        var otherSubmenu = otherToggle.nextElementSibling;
        otherToggle.setAttribute('aria-expanded', 'false');
        if (otherSubmenu) otherSubmenu.hidden = true;
      });

      submenuToggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      submenu.hidden = isOpen;

      if (!isOpen) {
        window.setTimeout(function () {
          submenuToggle.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }, 50);
      }
    });
  });

  // Cart link opens the existing AJAX cart drawer instead of navigating,
  // when it's available (mbg-cart.js exposes theme.CartDrawer once it's
  // wired up); otherwise it falls through to the normal /cart navigation.
  var cartLink = drawer.querySelector('[data-mbg-mobile-cart-open]');
  if (cartLink) {
    cartLink.addEventListener('click', function (evt) {
      if (window.theme && window.theme.CartDrawer) {
        evt.preventDefault();
        closeDrawer();
        window.theme.CartDrawer.open();
      } else {
        closeDrawer();
      }
    });
  }

  // Close (without navigating) if the viewport grows past the mobile
  // breakpoint while the drawer is open, matching the old module's
  // behaviour of not leaving a mobile-only panel open on desktop.
  var mobileBreakpoint = window.matchMedia('(max-width: 749px)');
  function handleBreakpointChange(mq) {
    if (!mq.matches && drawer.classList.contains('mbg-mobile-drawer--open')) {
      closeDrawer();
    }
  }
  if (mobileBreakpoint.addEventListener) {
    mobileBreakpoint.addEventListener('change', handleBreakpointChange);
  }
})();
